import type { SelectionCandidate } from './selection-candidate';

/** A box drawn on one rendered page, as fractions of the page from its top-left corner. */
export interface RegionCandidate {
  page: number;
  /** Revision of the pages on which the box was drawn. */
  revision?: number;
  left: number;
  top: number;
  width: number;
  height: number;
  /** The style the pages were rendered with, when not the document's own. */
  styleId?: string | null;
}

/** What a new comment points at: text selected in the editor, or a box drawn on the pages. */
export type CommentDraft =
  | { kind: 'text'; candidate: SelectionCandidate }
  | { kind: 'region'; region: RegionCandidate };

export const isRegionDraft = (
  draft: CommentDraft
): draft is { kind: 'region'; region: RegionCandidate } => draft.kind === 'region';
